<template>
   <div class="chat-input">
      <input type="text" :placeholder="placeholder" v-model="data">
      <button @click="send"></button>
   </div>
</template>

<script>
export default {
   name: 'chat-input',
   props: {
      placeholder: String,
      mb: String,
      type: {
         type: String,
         default: 'text'
      }
   },
   methods: {
      send() {
         this.$emit('send', this.data);
         this.data = null;
      }
   },
   data: () => ({
      data: null
   })
}
</script>

<style scoped lang="scss">
.chat-input {
   position: relative;
   height: 48.75px;
   width: 100%;

   input {
      width: 100%;
      height: 100%;
      background: #FFFFFF;
      border: 1px solid #DBBFA7;
      border-radius: 5px;
      padding-left: 20px;
      color: #383838;
      font-size: 16px;

      &::placeholder {
         font-size: 16px;
         color: #808080;
      }
   }

   button {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      background-color: transparent;
      border: none;
      background-image: url('../../../assets/images/icons/send.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      cursor: pointer;
   }
}
</style>